/*
Пример подключения модулей:
test.js: 
export default function() {}
main.js:
import test from './test';
test();
*/

import Authorization from './components/authorization';
import Objects from './components/info-objects';
import Media from './components/media';
import {initHeaderShare} from "./components/header-share";
import ScrollTo from './components/scroll-to';
// import SliderObjects from './components/slider';

$(function() {
	Authorization.init();
	Objects.init();
	Media.init();
	initHeaderShare();
	ScrollTo.init();
	// SliderObjects.init();
});